import { Dropdown } from '@/components/Dropdown';
import { ListItemText } from '@/components/Dropdown/MenuItems/components';
import styled from '@emotion/styled';
import { SxProps } from '@mui/material/styles';
import React, { useState } from 'react';

interface VoiceModelDropdownProps {
    options: string[];
    selected: string;
    onChange: (option: string) => void;
}

const DropdownTrigger = styled.div`
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.4rem;
`;

const paperStyles: () => SxProps = () => ({
    padding: '0 1rem',
    borderRadius: '1.2rem',
    boxShadow: '0px 10px 60px 0px #00000033',
    width: '320px',

    '&:focus': {
        outline: 'none',
        fontSize: '1.4rem',
    },

    ul: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        fontSize: '1.4rem',
    },

    'ul li': {
        borderRadius: '1.2rem',
        fontSize: '1.4rem',
        padding: '10px',
    },
});

export const VoiceModelDropdown: React.FC<VoiceModelDropdownProps> = ({ options, selected, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    const items = options.map(option => ({
        label: (
            <div
                style={{
                    padding: '10px',
                    cursor: 'pointer',
                    fontWeight: option === selected ? 'bold' : 'normal',
                    backgroundColor: option === selected ? '#f0f0f0' : 'transparent',
                }}
                onClick={() => {
                    onChange(option);
                    setIsOpen(false);
                }}>
                {option}
            </div>
        ),
    }));

    return (
        <Dropdown
            trigger={
                <DropdownTrigger onClick={() => setIsOpen(prev => !prev)}>
                    <ListItemText>{selected}</ListItemText>
                    <span style={{ marginLeft: '10px' }}>{isOpen ? '▲' : '▼'}</span>
                </DropdownTrigger>
            }
            items={items}
            closed={!isOpen}
            onClose={() => setIsOpen(false)}
            onOpen={() => setIsOpen(true)}
            sx={paperStyles()}
        />
    );
};
